import React from 'react';
import Router from './routers/router';

function App() {
  return (
    <Router />
  );
}

export default App;
